/**
 * Icon — 24-path Lucide-derived stroke set.
 * Ported verbatim from .agents/design/project/icons.jsx so the design bundle
 * and the production set can never drift.
 */

const ICON_PATHS = {
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm10 2-4.35-4.35',
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  filter: 'M3 5h18M6 12h12M10 19h4',
  download: 'M12 3v12m0 0 4-4m-4 4-4-4M4 19h16',
  upload: 'M12 21V9m0 0 4 4m-4-4-4 4M4 5h16',
  more: 'M5 12h.01M12 12h.01M19 12h.01',
  close: 'M6 6l12 12M6 18 18 6',
  edit: 'M4 20h4l10-10-4-4L4 16v4Zm10-10 4 4',
  check: 'M5 12l5 5 9-11',
  arrowRight: 'M5 12h14m-6-6 6 6-6 6',
  arrowDown: 'M12 5v14m-6-6 6 6 6-6',
  arrowUp: 'M12 19V5m-6 6 6-6 6 6',
  chevronD: 'M6 9l6 6 6-6',
  chevronR: 'M9 6l6 6-6 6',
  chevronL: 'M15 6l-6 6 6 6',
  command: 'M9 6h6m-6 12h6M6 9V6h3m6 0h3v3m0 6v3h-3m-6 0H6v-3',
  sun: 'M12 4V2m0 20v-2M4 12H2m20 0h-2m-2.93-7.07-1.42 1.42M6.34 17.66l-1.41 1.41m12.73 0-1.41-1.41M6.34 6.34 4.93 4.93M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z',
  moon: 'M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z',
  users: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2m20 0v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z',
  car: 'M5 17h14M5 17a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm14 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-1-7H6L4 14v3h16v-3l-2-4Zm-12 0 1.5-4h9L18 10',
  key: 'M14 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 9 2 15v3h3v-2h2v-2h2',
  wallet: 'M3 7h18a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Zm0 0V6a1 1 0 0 1 1-1h13M17 13h2',
  wrench: 'M14.7 6.3a4 4 0 0 0-5 5L3 18l3 3 6.7-6.7a4 4 0 0 0 5-5L15 7l-2-2 1.7-1.7Z',
  mail: 'M3 7h18v12H3V7Zm0 0 9 7 9-7',
  calendar: 'M3 8h18M3 8v11h18V8M3 8V5h18v3M8 3v4m8-4v4',
  chart: 'M4 20h16M6 16V9m4 7V5m4 11v-9m4 9v-5',
  'user-check':
    'M12 14H6a4 4 0 0 0-4 4v2m12-6a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm5 5 2 2 4-4',
  warehouse: 'M3 10v10h18V10L12 4 3 10Zm4 4h10v6H7v-6Z',
  archive: 'M3 5h18v4H3V5Zm2 4v10h14V9M9 13h6',
  layout: 'M3 4h18v6H3V4Zm0 10h8v6H3v-6Zm12 0h6v6h-6v-6Z',
  list: 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
  grid: 'M4 4h7v7H4V4Zm9 0h7v7h-7V4ZM4 13h7v7H4v-7Zm9 0h7v7h-7v-7Z',
  bell: 'M18 16V11a6 6 0 1 0-12 0v5l-2 3h16l-2-3Zm-6 5a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2Z',
  settings:
    'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm8-3-1.5-1 .5-2-2-1 .5-2-2-.5-1-2-2 .5-1-2-2 .5L9 2 8 4l-2-.5-1 2-2 .5.5 2-2 1 .5 2L1 12l1.5 1-.5 2 2 1-.5 2 2 .5 1 2 2-.5 1 2 2-.5 1 2 2-.5L15 22l1-2 2 .5 1-2 2-.5-.5-2 2-1-.5-2L20 12Z',
  snow: 'M12 2v20M2 12h20m-7-7-3 3-3-3m6 14-3-3-3 3M5 5l3.5 3.5M19 19l-3.5-3.5M5 19l3.5-3.5M19 5l-3.5 3.5',
  sun2: 'M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm0-16v2m0 16v2m10-10h-2M4 12H2m15.07-7.07-1.42 1.42M6.34 17.66l-1.41 1.41',
  pin: 'M12 21l-5-7a6 6 0 1 1 10 0l-5 7Zm0-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
  tire: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 4a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 0v-4m0 18v-4m5-5h4m-18 0h4M8.5 8.5 5.6 5.6m12.8 12.8-2.9-2.9M8.5 15.5l-2.9 2.9M18.4 5.6l-2.9 2.9',
  inbox:
    'M22 12h-6l-2 3h-4l-2-3H2m20 0V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7m20 0v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7',
  building:
    'M3 21V5l9-3 9 3v16M3 21h18M9 9h.01M9 13h.01M9 17h.01M15 9h.01M15 13h.01M15 17h.01',
  tag: 'M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82ZM7 7h.01',
  history: 'M3 12a9 9 0 1 0 9-9M3 12V5m0 7h7m2-2v4l3 2',
  external: 'M14 3h7v7M10 14 21 3M19 14v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6',
  home: 'M3 10l9-7 9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1V10Z',
  copy: 'M8 4h11a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1ZM4 9v11a1 1 0 0 0 1 1h11',
  lock: 'M5 11h14v10H5V11Zm3 0V7a4 4 0 1 1 8 0v4',
  clock: 'M12 7v5l3 2m6-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
} as const;

export type IconName = keyof typeof ICON_PATHS;

interface IconProps {
  name: IconName;
  size?: number;
  stroke?: number;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

export function Icon({
  name,
  size = 16,
  stroke = 1.6,
  className = '',
  style,
  title,
}: IconProps) {
  const d = ICON_PATHS[name];
  // Split the merged path into separate <path> elements — matches design source.
  const segments = d.split('M').filter(Boolean);

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={{ flexShrink: 0, ...style }}
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      {title && <title>{title}</title>}
      {segments.map((p, i) => (
        <path key={i} d={'M' + p} />
      ))}
    </svg>
  );
}
